var React = require('react');

function PrivacyDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m6.282 14.204.158 1.426A33.209 33.209 0 0 0 24 41.36a33.209 33.209 0 0 0 17.56-25.73l.158-1.427-6.667-6.666a26.02 26.02 0 0 1-22.102 0l-6.667 6.667zM12 0a20 20 0 0 0 24 0l12 12-.477 4.292A39.208 39.208 0 0 1 24 48 39.208 39.208 0 0 1 .477 16.292L0 12 12 0z","fill":"#8D6CFF"}));
}

PrivacyDark.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = PrivacyDark;

PrivacyDark.default = PrivacyDark;
